// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"os","editButton":"ot","formClass":"ou","rowClass":"ov","columnClass":"ow","inputClass":"ox","email":"oy","mobile":"oz","cancelButton":"oA","submitButton":"oB"};